module.exports = __webpack_public_path__ + "img/Weapon_180.ffc75f3a.png";